module.exports = __webpack_public_path__ + "img/2.cef4e6c0.jpg";